import { ONE } from 'config/apis'

const sendLogin = async ({ data, club }) => {
  const { user, pass } = data
  const headersWithPass = { ...ONE.HEADERS }
  headersWithPass.headers.password = pass
  try {
    const req = await fetch(
      ONE[`PRIVATE_${club ? 'CLUB_' : ''}LOGIN`].replace('{user}', user),
      {
        method: 'GET',
        ...headersWithPass
      }
    )
    const parsed = await req.json()
    return parsed
  } catch (err) {
    console.log(err)
  }
}

const recoverPasswordReq = async ({ id, birthDate, document, email }) => {
  try {
    const req = await fetch(
      `${ONE.PRIVATE_ACCESS_REQUEST.replace(
        '{id}',
        id
      )}?birthDate=${birthDate}&document=${document}&email=${email}`,
      ONE.HEADERS
    )
    const parsed = await req.json()
    return parsed
  } catch (err) {
    console.log(err)
  }
}

export { sendLogin, recoverPasswordReq }
